import { IControlProvider } from '@ibiz-template/runtime';
/**
 * 列表适配器
 *
 * @author lxm
 * @date 2022-10-25 18:10:57
 * @export
 * @class ChartProvider
 * @implements {IControlProvider}
 */
export class ChartProvider implements IControlProvider {
  component: string = 'IBizChartControl';
}
